import { html } from 'lit';
const Reddit =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"/><path fill='currentColor' d="M18.652 12.095c0-.81-.655-1.454-1.454-1.454-.378 0-.74.145-1.013.405-1.002-.715-2.373-1.18-3.899-1.24l.668-3.123 2.17.465a1.037 1.037 0 1 0 1.037-1.085c-.406 0-.763.238-.93.584l-2.42-.513a.25.25 0 0 0-.191.036.23.23 0 0 0-.107.167l-.74 3.481c-1.55.048-2.944.513-3.958 1.24a1.46 1.46 0 0 0-1.013-.405 1.452 1.452 0 0 0-.596 2.778 2.6 2.6 0 0 0-.036.44c0 2.242 2.611 4.066 5.83 4.066s5.83-1.812 5.83-4.065a3 3 0 0 0-.036-.441c.5-.227.858-.74.858-1.336m-9.99 1.037a1.038 1.038 0 1 1 1.037 1.038c-.572.011-1.037-.465-1.037-1.038m5.806 2.754c-.715.716-2.075.764-2.468.764-.405 0-1.764-.06-2.468-.764a.267.267 0 0 1 0-.381.267.267 0 0 1 .382 0c.453.453 1.406.608 2.086.608s1.645-.155 2.086-.608a.267.267 0 0 1 .382 0 .29.29 0 0 1 0 .381m-.191-1.704a1.038 1.038 0 1 1 1.037-1.037c0 .56-.464 1.037-1.037 1.037"/>
  </svg>
`;
export default Reddit;
